import { RouteObject } from "react-router-dom";
import { ACCOUNT_MEMBER } from "constants/urls";

export default [
  {
    index: true,
    path: ACCOUNT_MEMBER,
    lazy: () => import("modules/account-member/pages/AccountMember"),
  },
] as RouteObject[];
